import { createSlice } from "@reduxjs/toolkit";


// tabsSlice.js
const initialState = {
  tabs: [],
  selectedTab: null,
};

const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    setTabs: (state, action) => {
      state.tabs = action.payload;
      state.selectedTab = action.payload[0];
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
  },
});

export const { setTabs, setSelectedTab } = tabsSlice.actions;
export default tabsSlice.reducer;
